/**
 * Converts milliseconds to MM:SS format for video timestamps
 * @param milliseconds - Time in milliseconds
 * @returns Formatted time string (MM:SS or HH:MM:SS for videos longer than an hour)
 */
export const formatTime = (milliseconds: number): string => {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Format with leading zeros
  const pad = (num: number): string => num.toString().padStart(2, '0');

  if (hours > 0) {
    // Format as HH:MM:SS for videos longer than an hour
    return `${hours}:${pad(minutes)}:${pad(seconds)}`;
  }

  // Format as MM:SS for videos under an hour
  return `${minutes}:${pad(seconds)}`;
};
